import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { alignComponent } from 'Actions/styleActions';
import WveInputButton from 'SharedComponents/WveInputs/WveInputButton/WveInputButton';

const ButtonsContainer = styled.div`
  width: 70%;
  display: flex;
  justify-content: flex-end;
`;

const Button = styled(WveInputButton)`
  padding-left: 5px;
  padding-right: 5px;
  background: transparent;
  border: 0;

  &:hover {
    background: transparent;
    border: 0;
  }
`;

const alignmentButtons = [
  {
    icon: 'alignleft',
    axis: 'x',
    alignment: 'start',
  },
  {
    icon: 'alignhorizontal',
    axis: 'x',
    alignment: 'center',
  },
  {
    icon: 'alignright',
    axis: 'x',
    alignment: 'end',
  },
  {
    icon: 'aligntop',
    axis: 'y',
    alignment: 'start',
  },
  {
    icon: 'alignvertical',
    axis: 'y',
    alignment: 'center',
  },
  {
    icon: 'alignbottom',
    axis: 'y',
    alignment: 'end',
  },
];

const WveInputAlignment = ({ alignComponent }) => // eslint-disable-line no-shadow

  <ButtonsContainer>
    { alignmentButtons.map(button =>
      <Button
        onClick={() => alignComponent(button.axis, button.alignment)}
      >
        <i className={`wve-icon wve-icon-${button.icon}`} />
      </Button>,
    )}
  </ButtonsContainer>;

WveInputAlignment.propTypes = {
  alignComponent: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  alignComponent: (axis, alignment) => {
    dispatch(alignComponent(axis, alignment));
  },
});

export default connect(null, mapDispatchToProps)(WveInputAlignment);



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/WveInputs/WveInputAlignment/WveInputAlignment.jsx